/** @jsx jsx */
import { jsx, css, SerializedStyles } from '@emotion/react';
import { ReactNode } from 'react';
import { useAppConfig } from '../hooks/useAppConfig';

interface IProps {
  title?: string;
  size?: string;
  css?: SerializedStyles;
  children?: ReactNode;
}

export default (props: IProps) => {
  const { title, children, size } = props;
  const { getColor } = useAppConfig();
  return (
    <p
      {...props}
      css={css(
        `
        color: ${getColor('primary')};
        font-size: ${size || '12px'};
        font-weight: bold;
      `,
        props.css
      )}
    >
      {title || children}
    </p>
  );
}
